import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import { FaqIntro } from '@/sections/FaqIntro';
import React from 'react';
export function Faq() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopWisely"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = LINKS();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = t1.faq;
  let t3;
  if ($[2] !== t) {
    t3 = t("faq.text");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <FaqIntro link={t2} text={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}